import { Validate } from '@deporvillage/utils-library-component';

const Customer = {
    password: {
        id: 'password',
        type: 'password',
        label: 'form.label.password',
        value: null,
        error: null,
        validate: [
            Validate.required,
            Validate.password,
        ],
    },
    passwordConfirmation: {
        id: 'passwordConfirmation',
        type: 'password',
        label: 'form.label.password_confirmation',
        value: null,
        error: null,
        validate: [
            Validate.required,
            Validate.passwordConfirmation,
        ],
    },
};
export default Customer;
